<div class="userSettingPages">
  <div class="headerDecs">
    <h2>{{ 'Document_Download' | t }}</h2>
    <span>{{ 'Account_Download_Desc' | t }}</span>
  </div>

  <div *ngIf="!IsReLogin">
    <form class="example-form" [formGroup]="reloginDatas">
      <mat-form-field class="example-full-width">
        <input matInput placeholder="{{ 'user_name' | t }}" formControlName="userName" />
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <input matInput placeholder="{{ 'password' | t }}" type="password" formControlName="userPassword" />
      </mat-form-field>
    </form>

    <button mat-raised-button class="Account-Documents-Submit-Button" (click)="submitLoginData()" [disabled]="!reloginDatas.valid">
      <span style="color: white">
        {{ 'login' | t }}
      </span>
    </button>
  </div>

  <div *ngIf="IsReLogin" style="margin-top: 5px">
    <div style="margin-bottom: 5px; width: 100%">
      <button mat-flat-button style="background: linear-gradient(135deg, #0277ff 0%, #00bbce 100%); width: 100%" (click)="dwnPersonal()">
        <span style="color: white">
          {{ 'Download_Personal_Information' | t }}
        </span>
      </button>
    </div>

    <div style="margin-bottom: 5px; width: 100%">
      <button mat-flat-button style="background: linear-gradient(135deg, #0277ff 0%, #00bbce 100%); width: 100%" (click)="dwnBookings()">
        <span style="color: white">
          {{ 'Download_Bookings' | t }}
        </span>
      </button>
    </div>

    <div style="margin-bottom: 5px; width: 100%">
      <button mat-flat-button style="background: linear-gradient(135deg, #0277ff 0%, #00bbce 100%); width: 100%" (click)="dwnSlips()">
        <span style="color: white">
          {{ 'Download_Slips' | t }}
        </span>
      </button>
    </div>

    <div style="margin-bottom: 5px; width: 100%">
      <button mat-flat-button style="background: linear-gradient(135deg, #0277ff 0%, #00bbce 100%); width: 100%" (click)="dwnDocuments()">
        <span style="color: white">
          {{ 'Download_Documents' | t }}
        </span>
      </button>
    </div>

    <div style="margin-bottom: 5px; width: 100%">
      <button mat-flat-button style="background: linear-gradient(135deg, #0277ff 0%, #00bbce 100%); width: 100%" (click)="dwnSupportMessage()">
        <span style="color: white">
          {{ 'Download_Support_Messages' | t }}
        </span>
      </button>
    </div>
  </div>
</div>
